<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation ref="navigation"></navigation>
    </div>
    <div class="sy_main">
      <!--<div class="sy_position">您当前的位置：<router-link  :to="{ path: '/'}" >首页</router-link> &gt;&gt; 学会活动</div>-->
      <div class="sym_content2">
        <div class="symc2">
          <div class="symc2_box">
            <div class="symc2_box_title"><img src="../assets/img/secondary_h3_pic.gif" width="21" height="15" /><a href="javascript:;">站内搜索</a></div>
            <div class="symc2_box_main" style="font-style: normal">
              <ul>
                <li v-for="(item,index) in newsList" :key="item.id"  v-if="(settings.isSubject  && index>0 ) || !settings.isSubject">
                  <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                </li>
              </ul>
            </div>
            <div class="new_num_list" id="coursePageUl">
              <el-pagination
                small="true"
                @current-change="handleCurrentChange"
                :current-page.sync="settings.pageNum"
                :page-size="settings.pageSize"
                layout="prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
        <!--右侧3竖模块-->
        <div class="symc_right">
          <login></login>
          <latestNewsSimple></latestNewsSimple>
        </div>
      </div>
      <div class=""></div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
  import {search} from '../api/api';
  import  header2 from '../components/Header2'
  import  navigation from '../components/Navigation'
  import  footer1 from '../components/Footer1'
  import  login from '../components/Login'
  import  latestNewsSimple from '../components/LatestNewsSimple'
  import util from '../common/js/util'
  export default {
    components: {
      latestNewsSimple,
      header2,
      login,
      footer1,
      navigation
    },
    data () {
      return {
        settings: {
          keyword:this.$route.query.keyword,
          consultIds: '32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,50,51,56',
          publishState: 0,
          publishTime: util.formatDate.format(new Date(), 'yyyy-MM-dd hh:mm:ss'),
          pageNum:1,
          pageSize: 30
        },
        total:0,
        newsList:[],
        secondCarousel: null
      }
    },
    mounted () {
      document.getElementById("J_GotoTop").style.visibility="hidden";//隐藏在线客服
      this.initSearch();
    },
    destroyed () {
      document.getElementById("J_GotoTop").style.visibility="visible" //显示在线客服
    },
    computed: {},
    methods: {
      initSearch(){
        search(this.settings).then((response) => {
          this.newsList = response.data.list;
          this.total = response.data.total;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.settings.pageNum = val;
        this.initSearch();
      },
    },
    watch: {
      keyword: function (val) {
        if(val!='' && this.settings.keyword!=val){
          this.settings.keyword=val;
          this.initSearch();
        }
      }
    },
    computed: {
      keyword() {
        return this.$route.query.keyword
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>



// WEBPACK FOOTER //
// src/views/MedicalSearch.vue